
import { useCallback } from 'react'
import {
  ApiGetWithToken,
  ApiPostWithToken,
  useApiFetch,
  useApiPost
} from 'shared/api'
import { searchApiBy } from 'interface/endpoints'
import { EvaluationResultList, EvaluationResultFormData, EvaluationResultListFormData, PostEvaluationResult } from './types'
import { useUpdateTime } from 'interface/util'

export * from './types'

export const useListEvaluationResults = (
  searchId?: number | null,
  updateTime?: string | null
) => {
  const t = useUpdateTime(updateTime)
  return useApiFetch(
    useCallback(
      (apiAccess, cancelToken, fetchTime) => {
        if (!searchId) return null
        return ApiGetWithToken<EvaluationResultList>(
          apiAccess,
          searchApiBy(searchId, "/evaluation/list", { t: fetchTime ?? t }),
          cancelToken
        )
      },
      [t, searchId]
    )
  )
}

export const useListEvaluationResultsByKojin = (
  searchId?: number | null,
  kojinCode?: string | null
) => useApiFetch(
  useCallback(
    (apiAccess, cancelToken) => {
      if (!searchId || !kojinCode) return null
      return ApiGetWithToken<EvaluationResultList>(
        apiAccess,
        searchApiBy(searchId, `/evaluation/${kojinCode}`),
        cancelToken
      )
    },
    [searchId, kojinCode]
  )
)

export const usePostEvaluationResult = (
  searchId: number,
  kojinCode: string,
  callback?: {
    onPosted?: (result: PostEvaluationResult) => void
    onError?: (reason: Error | undefined) => void
  }
) => useApiPost<EvaluationResultFormData, PostEvaluationResult>(
  useCallback(
    (apiAccess, cancelToken, form, webSocketId) => {
      return ApiPostWithToken(
        apiAccess,
        searchApiBy(searchId, `/evaluation/${kojinCode}`),
        form,
        cancelToken,
        webSocketId
      )
    },
    [searchId, kojinCode]
  ),
  useCallback(
    (result) => {
      if (callback?.onPosted) callback.onPosted(result)
      return result
    },
    [callback]
  ),
  useCallback(
    (reason) => {
      if (callback?.onError) callback?.onError(reason)
    },
    [callback]
  )
)

export const usePostEvaluationResultList = (
  searchId: number,
  callback?: {
    onPosted?: (result: PostEvaluationResult) => void
    onError?: (reason: Error | undefined) => void
  }
) => useApiPost<EvaluationResultListFormData, PostEvaluationResult>(
  useCallback(
    (apiAccess, cancelToken, form, webSocketId) => {
      return ApiPostWithToken(
        apiAccess,
        searchApiBy(searchId, '/evaluation/list'),
        form,
        cancelToken,
        webSocketId
      )
    },
    [searchId]
  ),
  useCallback(
    (result) => {
      if (callback?.onPosted) callback.onPosted(result)
      return result
    },
    [callback]
  ),
  useCallback(
    (reason) => {
      if (callback?.onError) callback?.onError(reason)
    },
    [callback]
  )
)


